// Vuex 根 store
import { createStore } from 'vuex'
import nav from './modules/nav.js'
import footer from './modules/footer.js'
import hero from './modules/hero.js'
import locale from './modules/locale.js'
import productCategories from './modules/productCategories.js'
import products from './modules/products.js'
import solutions from './modules/solutions.js'
import about from './modules/about.js'
import join from './modules/join.js'
import news from './modules/news.js'
import legalPage from './modules/legalPage.js'
import homeSections from './modules/homeSections.js'
import webmaster from './modules/webmaster.js'
import access from './modules/access.js'

export default createStore({
  modules: {
    nav,
    footer,
    hero,
    locale,
    productCategories,
    products,
    solutions,
    about,
    join,
    news,
    legalPage,
    homeSections,
    webmaster,
    access
  }
})
